import { create } from "zustand";
import { persist } from "zustand/middleware";

const useFilterStore = create(
  persist(
    (set) => ({
      filterText: "",
      selectedCategory: "",
      selectedSubCategory: "",
      orderBy: "",
      categorySearch: "",

      setFilterText: (value) => set({ filterText: value }),
      setSelectedCategory: (value) => set({ selectedCategory: value }),
      setSelectedSubCategory: (value) => set({ selectedSubCategory: value }),
      setOrderBy: (value) => set({ orderBy: value }),
      setCategorySearch: (value) => set({ categorySearch: value }),

      clearFilter: () =>
        set({
          filterText: "",
          selectedCategory: "",
          selectedSubCategory: "",
          orderBy: "",
          categorySearch: "",
        }),
    }),
    {
      name: "@aqvex/filter-storage",
      version: 1,
    },
  ),
);

export default useFilterStore;
